<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    href: '#/landing-packages',
                    exact: true,
                },
                { text: 'Paket Landing Page' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Paket Landing Page</h3>

        <v-card>
            <v-card-title> Daftar Paket </v-card-title>
            <v-divider />

            <v-list three-line style="min-height: none !important" class="pa-0">
                <template>
                    <v-list-item
                        v-for="card in liveClasses"
                        v-bind:key="card.id"
                        @click="
                            selectedRow = card;
                            editliveClass();
                        "
                    >
                        <v-list-item-content
                            class="pt-4 pb-6 ml-2"
                            style="max-width: 45px"
                        >
                            <v-list-item-subtitle>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    ID
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ card.id }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-content class="pt-4 pb-6">
                            <v-list-item-subtitle>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    Nama
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ card.category_name }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action class="d-flex align-self-center">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/components/plugins/Spinner";
import DataTable from "@/components/plugins/DataTable";

export default {
    name: "LandingPackageList",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            liveClasses: [],
            datas: null,
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: ["ID", "Nama"],
            headersKey: ["id", "category_name"],
        };
    },

    mounted: function () {
        this.$store.commit("landing_packages_clear");
        this.fetchDatas();
    },

    methods: {
        async fetchDatas() {
            var context = this;
            this.isLoading = true;
            try {
                const resp = await this.$alioss.get(
                    `/config/package_landing_page.json`,
                );
                this.datas = JSON.parse(resp.res.data).packages;
                this.$store.commit("packages_init", this.datas);
                this.$store.commit(
                    "packages_init_raw",
                    JSON.parse(resp.res.data),
                );

                this.datas.forEach(function (group) {
                    var row = {
                        id: group.id,
                        category_name: group.category_name,
                    };

                    context.liveClasses.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                // isLoading hanya direset di jalur sukses, jadi tanpa baris ini
                // spinner berputar selamanya saat OSS gagal.
                context.isLoading = false;
                alert(error);
            }
        },

        editliveClass: function () {
            var context = this;
            var groupId = this.selectedRow.id;
            context.$router.push("/landing-packages/" + groupId);
        },
    },
};
</script>



// WEBPACK FOOTER //
// LandingPackage.vue?3f105e68